<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-grid">
        <!-- Brand -->
        <div class="footer-col footer-brand">
          <router-link to="/" class="footer-logo">
            <img src="../assets/logo.png" alt="Multimedia Agency" />
          </router-link>
          <p class="brand-tagline">
            We help brands stand out with creative strategy, design and
            production that move the needle.
          </p>
          <div class="brand-social">
            <a
              v-for="s in socials"
              :key="s.name"
              :href="s.url"
              target="_blank"
              rel="noopener"
              :aria-label="s.name"
              class="social-link"
            >
              <i :class="s.icon"></i>
            </a>
          </div>
        </div>

        <!-- Quick links -->
        <div class="footer-col">
          <h4 class="col-title">Explore</h4>
          <ul class="footer-links">
            <li><router-link to="/">Home</router-link></li>
            <li><router-link to="/services">Services</router-link></li>
            <li><router-link to="/works">Portfolio</router-link></li>
            <li><router-link to="/about">About</router-link></li>
            <li><router-link to="/jobs">Jobs</router-link></li>
            <li><router-link to="/contact">Contact</router-link></li>
          </ul>
        </div>

        <!-- Contact -->
        <div class="footer-col">
          <h4 class="col-title">Get in touch</h4>
          <ul class="contact-list">
            <li>
              <a
                href="https://maps.app.goo.gl/QHN1rGkc3EeBKhYZ8"
                target="_blank"
                rel="noopener"
              >
                <span class="contact-icon">
                  <i class="fa-solid fa-location-dot"></i>
                </span>
                <span>
                  Media City, Floor 8<br />
                  Shaqlawa Road, Erbil, Iraq
                </span>
              </a>
            </li>
            <li>
              <a href="tel:+9647509838383">
                <span class="contact-icon">
                  <i class="fa-solid fa-phone"></i>
                </span>
                <span>+964 750 983 8383</span>
              </a>
            </li>
            <li>
              <a href="tel:+9647719838383">
                <span class="contact-icon">
                  <i class="fa-solid fa-phone"></i>
                </span>
                <span>+964 771 983 8383</span>
              </a>
            </li>
            <li>
              <a href="mailto:info@magency.me">
                <span class="contact-icon">
                  <i class="fa-solid fa-envelope"></i>
                </span>
                <span>info@magency.me</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer-divider"></div>

      <div class="footer-bottom">
        <p class="copyright">
          © {{ year }} Multimedia Agency. All rights reserved.
        </p>
        <p class="legal-links">
          <a href="mailto:info@magency.me">Have feedback?</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
      socials: [
        {
          name: "Facebook",
          url: "https://www.facebook.com/multimediaagencyiraq",
          icon: "fa-brands fa-facebook-f",
        },
        {
          name: "Instagram",
          url: "https://www.instagram.com/multimedia_agency/",
          icon: "fa-brands fa-instagram",
        },
        {
          name: "LinkedIn",
          url: "https://www.linkedin.com/company/ma-interact/",
          icon: "fa-brands fa-linkedin-in",
        },
      ],
    };
  },
};
</script>

<style scoped>
.site-footer {
  position: relative;
  margin-top: 80px;
  padding: 60px 0 24px;
  color: #c8cee0;
  background: linear-gradient(
    180deg,
    rgba(10, 8, 45, 0) 0%,
    rgba(10, 8, 45, 0.6) 30%,
    rgba(10, 8, 45, 0.9) 100%
  );
}

.site-footer::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: min(960px, 90%);
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(85, 181, 236, 0.5),
    rgba(98, 33, 126, 0.5),
    transparent
  );
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1.2fr;
  gap: 48px;
  padding-bottom: 40px;
}

.footer-col {
  display: flex;
  flex-direction: column;
}

/* ============ BRAND ============ */
.footer-logo {
  display: inline-block;
  margin-bottom: 18px;
}

.footer-logo img {
  width: 110px;
  height: auto;
  display: block;
}

.brand-tagline {
  font-size: 15px;
  line-height: 1.7;
  color: #9ea4cc;
  margin: 0 0 22px;
  max-width: 400px;
}

.brand-social {
  display: flex;
  gap: 12px;
}

.social-link {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  text-decoration: none;
  font-size: 15px;
  transition: transform 0.2s ease, background 0.2s ease,
    border-color 0.2s ease;
}

.social-link:hover {
  transform: translateY(-3px);
  background: linear-gradient(135deg, #55b5ec 0%, #62217e 100%);
  border-color: transparent;
  color: #ffffff;
}

/* ============ COLUMN TITLE ============ */
.col-title {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #ffffff;
  margin: 6px 0 22px;
  position: relative;
  display: inline-block;
}

.col-title::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 28px;
  height: 2px;
  border-radius: 1px;
  background: linear-gradient(90deg, #55b5ec, #62217e);
}

/* ============ LINKS ============ */
.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-links a {
  color: #b9c3d1;
  text-decoration: none;
  font-size: 15px;
  display: inline-block;
  position: relative;
  transition: color 0.2s ease, transform 0.2s ease;
}

.footer-links a::before {
  content: "";
  position: absolute;
  left: -14px;
  top: 50%;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: linear-gradient(135deg, #55b5ec, #62217e);
  transform: translateY(-50%) scale(0);
  transition: transform 0.2s ease;
}

.footer-links a:hover {
  color: #ffffff;
  transform: translateX(14px);
}

.footer-links a:hover::before {
  transform: translateY(-50%) scale(1);
}

/* ============ CONTACT LIST ============ */
.contact-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.contact-list a {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  color: #b9c3d1;
  text-decoration: none;
  font-size: 15px;
  line-height: 1.5;
  transition: color 0.2s ease;
}

.contact-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #55b5ec;
  font-size: 14px;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.contact-list a:hover {
  color: #ffffff;
}

.contact-list a:hover .contact-icon {
  background: linear-gradient(135deg, #55b5ec 0%, #62217e 100%);
  border-color: transparent;
  color: #ffffff;
}

/* ============ BOTTOM ============ */
.footer-divider {
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.12),
    transparent
  );
  margin: 0 0 22px;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.copyright {
  margin: 0;
  font-size: 13px;
  color: #8b91b8;
  letter-spacing: 0.3px;
}

.legal-links {
  margin: 0;
  font-size: 13px;
}

.legal-links a {
  color: #8b91b8;
  text-decoration: none;
  transition: color 0.2s ease;
}

.legal-links a:hover {
  color: #55b5ec;
}

/* ============ RESPONSIVE ============ */
@media (max-width: 900px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 36px;
  }

  .footer-brand {
    grid-column: 1 / -1;
  }
}

@media (max-width: 600px) {
  .site-footer {
    padding: 48px 0 20px;
    margin-top: 56px;
  }

  .footer-grid {
    grid-template-columns: 1fr;
    gap: 32px;
    padding-bottom: 32px;
  }

  .footer-bottom {
    justify-content: center;
    text-align: center;
  }

  .brand-tagline {
    max-width: none;
  }
}
</style>
